import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';

const ModalHistorialComponent = (props) => {
    const historial = props.historial


    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        height: 300,
        bgcolor: '#E3EFF1',
        border: 'px solid #000',
        boxShadow: 24,
        p: 4,
        color: 'black'
    };

    const [openModalCompra, setOpenModalCompra] = React.useState(true);

    const handleCloseModal = () => {
        setOpenModalCompra(false)
        props.setOpenModalCompra.setOpenModalCompra()
    }

    const columns = [
        { field: 'pedido', headerName: 'No. Pedido', headerAlign: 'center', flex: .5 },
        { field: 'fecha', headerName: 'Fecha', headerAlign: 'center', flex: .5 },
        { field: 'prefijo', headerName: 'Prefijo', headerAlign: 'center', flex: .5 },
        { field: 'folioInicial', headerName: 'Folio Inicial', headerAlign: 'center', flex: 1 },
        { field: 'folioFinal', headerName: 'Folio Final', headerAlign: 'center', flex: 1 },
        {
            field: 'observaciones', headerName: 'Observaciones', headerAlign: 'center', flex: 1,
            renderCell: (params) =>
                <Tooltip title={`${params.row.observaciones}`} arrow>
                    <label>{`${params.row.observaciones}`}</label>
                </Tooltip>
        },
    ]

    const rows = [];
    historial?.map(anexo => {
        if (anexo?.prefijo != '') {
            rows.push({
                id: uuidv4(), pedido: anexo?.idcomprahologramas, prefijo: anexo?.prefijo,
                folioInicial: anexo?.folioinicial, folioFinal: anexo?.foliofinal,
                fecha: anexo?.fechaatendida?.substring(0, 10), observaciones: anexo?.observaciones
            })
        }
        else return null
    })


    const modalComponent = () => {
        return (
                <Modal open={openModalCompra} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description" >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" className='text-danger' style={{ color: "white" }}>
                            <h3 style={{ color: "#0D717C", fontFamily: "Montserrat", fontWeight: "bold", textAlign: 'center' }}>Detalle de compra</h3>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" style={{ color: "black", textAlign: 'justify' }}>
                            <Box sx={{ height: 150, width: '100%', mt: 2 }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    disableColumnMenu={true}
                                    pageSize={8}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#4399A4',
                                            color: 'white',
                                            fontFamily: 'Montserrat',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </Box>
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            <button className={`btn btn-outline-success`} style={{ width: '50%' }} onClick={() => handleCloseModal()}>Aceptar</button>
                        </Typography>
                    </Box>
                </Modal>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(ModalHistorialComponent)
